<div class="nova-font-style">
  <div class="top-margin-15"></div>
  <div class="row top-margin-15">
    <div class="col s12 m8 offset-m2 l6 offset-l3 xl4 offset-xl4 bottom-padding-10" id="card-view">
      <h2>Contact Information</h2>
      <form novalidate name="profileForm" #f="ngForm" (ngSubmit)="save()">
        <table aria-hidden="true" class="keyValuePairs">
          <tbody>
            <!-- Email Address -->
            <tr>
              <th id="table-head">
                <span>
                  Email Address:
                </span>
              </th>
              <td>
                <div>
                  <p>{{currentUserData.emailAddress}}</p>
                </div>
              </td>
            </tr>
            <!-- First Name -->
            <tr>
              <th id="table-head">
                <span>
                  First Name<span class="k-required">*</span>:
                </span>
              </th>
              <td>
                <div *ngIf="!isEditMode else editFirstName">
                  <p>{{currentUserData.firstName}}</p>
                </div>
                <ng-template #editFirstName>
                  <input id="userFirstName" placeholder="First Name" name="userFirstName" [(ngModel)]="user.firstName"
                    pattern="^[a-zA-Z\s.'\-,`]+$" maxlength="12" #userFirstName="ngModel" required ngDefaultControl />
                  <div class="top-margin-1" *ngIf="validations(f.form,'userFirstName')">
                    <span class="left-margin-0 tooltip-validation">
                      Valid First Name is required
                    </span>
                  </div>
                </ng-template>
              </td>
            </tr>
            <!-- Middle Initial -->
            <tr>
              <th id="table-head">
                <span>
                  Middle Initial:
                </span>
              </th>
              <td>
                <div *ngIf="!isEditMode else editMIName">
                  <p>{{currentUserData.middleName}}</p>
                </div>
                <ng-template #editMIName>
                  <input id="userMiddleName" placeholder="Middle Initial" name="userMiddleName"
                    [(ngModel)]="user.middleName" pattern="[a-zA-Z]" maxlength="1" #userMiddleName="ngModel"
                    ngDefaultControl />
                  <div class="top-margin-1" *ngIf="!userMiddleName.valid && userMiddleName.dirty == true">
                    <span class="left-margin-0 tooltip-validation">
                      Valid Middle Initial is required
                    </span>
                  </div>
                </ng-template>
              </td>
            </tr>
            <!-- Last Name -->
            <tr>
              <th id="table-head">
                <span>
                  Last Name<span class="k-required">*</span>:
                </span>
              </th>
              <td>
                <div *ngIf="!isEditMode else editLastName">
                  <p>{{currentUserData.lastName}}</p>
                </div>
                <ng-template #editLastName>
                  <input id="userLastName" placeholder="Last Name" name="userLastName" [(ngModel)]="user.lastName"
                    pattern="^[a-zA-Z\s.'\-,`]+$" maxlength="17" #userLastName="ngModel" required ngDefaultControl />
                  <div class="top-margin-1" *ngIf="validations(f.form,'userLastName')">
                    <span class="left-margin-0 tooltip-validation">
                      Valid Last Name is required
                    </span>
                  </div>
                </ng-template>
              </td>
            </tr>
            <!-- User Title -->
            <tr>
              <th id="table-head">
                <span>
                  Title:
                </span>
              </th>
              <td>
                <div *ngIf="!isEditMode else editTitle">
                  <p>{{currentUserData.jobTitle}}</p>
                </div>
                <ng-template #editTitle>
                  <input id="userJobTitle" placeholder="Title" name="userJobTitle" [(ngModel)]="user.jobTitle"
                    #userJobTitle="ngModel" />
                </ng-template>
              </td>
            </tr>
            <!-- Phone number -->
            <tr>
              <th id="table-head">
                <span>
                  Phone Number<span class="k-required">*</span>:
                </span>
              </th>
              <td>
                <div *ngIf="!isEditMode">
                  <p>{{ currentUserData.phoneNumber | phone }}</p>
                </div>
                <div *ngIf="isEditMode">
                  <kendo-maskedtextbox class="form-control" id="phNumber" maxlength="10" name="phone" #phone="ngModel"
                    [(ngModel)]="user.phoneNumber" [mask]="'(000) 000-0000'" [maskValidation]="maskValidation" required
                    ngDefaultControl></kendo-maskedtextbox>
                  <div class="top-margin-1" *ngIf="!phone.valid && phone.dirty == true">
                    <span class="left-margin-0 tooltip-validation">
                      Valid phone number is required
                    </span>
                  </div>
                </div>
              </td>
            </tr>
            <!-- Extension -->
            <tr>
              <th id="table-head">
                <span>
                  Extension:
                </span>
              </th>
              <td>
                <div *ngIf="!isEditMode">
                  <p>{{currentUserData.phoneNumberExtension}}</p>
                </div>
                <div *ngIf="isEditMode">
                  <kendo-maskedtextbox class="form-control" id="phNumberExt" [mask]="'000000'" [maskValidation]="false"
                    name="phoneExt" [(ngModel)]="user.phoneNumberExtension" #phoneExt="ngModel" ngDefaultControl>
                  </kendo-maskedtextbox>
                </div>
              </td>
            </tr>
            <!-- Phone number 2-->
            <tr>
              <th id="table-head">
                <span>
                  Phone Number 2:
                </span>
              </th>
              <td>
                <div *ngIf="!isEditMode">
                  <p>{{currentUserData.phoneNumber2 | phone}}</p>
                </div>
                <div *ngIf="isEditMode">
                  <kendo-maskedtextbox class="form-control" id="ph2Number" placeholder="Phone Number" maxlength="10"
                    name="secondPhone" #secondPhone="ngModel" [(ngModel)]="user.phoneNumber2" [mask]="'(000) 000-0000'"
                    [maskValidation]="maskValidation" ngDefaultControl></kendo-maskedtextbox>
                </div>
              </td>
            </tr>
            <!-- Extension 2-->
            <tr>
              <th id="table-head">
                <span>
                  Extension 2:
                </span>
              </th>
              <td>
                <div *ngIf="!isEditMode">
                  <p class="tableData">{{currentUserData.phoneNumber2Extension}}</p>
                </div>
                <div *ngIf="isEditMode">
                  <kendo-maskedtextbox class="form-control" id="phNumber2Ext" [mask]="'000000'" [maskValidation]="false"
                    name="phone2Ext" [(ngModel)]="user.phoneNumber2Extension" #phone2Ext="ngModel" ngDefaultControl>
                  </kendo-maskedtextbox>
                </div>
              </td>
            </tr>
            <!-- Change Password -->
            <tr>
              <td>
                <div class="row">
                  <div class="col s12 m12 l12 xl12 padding-0">
                    <a href="javascript:void(0);" class="clone-link" (click)="callChangePw()">Change Password</a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Buttons -->
        <div class="row">
          <div class="col s6 m6 l6 xl6">
            <button type="button" *ngIf="!isEditMode && operators.Edit" (click)="edit()" class="btn btn-primary"
              id="editBtn"><span class="k-icon k-i-edit"></span>Edit</button>
            <button type="button" *ngIf="isEditMode" (click)="cancel()" class="btn" [disabled]="isSaving"
              id="btn-cancel"><span class="k-icon k-i-cancel"></span> Cancel</button>
          </div>
          <div class="col s6 m6 l6 xl6 align-right">
            <button type="submit" *ngIf="isEditMode" class="btn btn-primary left-margin-5" id="btn-save"
              [disabled]="isSaving || !(f.valid && f.dirty )">
              <span class="k-icon k-i-save icon-margin"></span>
              {{isSaving ? 'Saving' : 'Save'}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <app-notification-loading></app-notification-loading>
</div>
<kendo-dialog title="Change Password" *ngIf="opened" class="payment-dialog" (close)="closePopup()"
  id="changePasswordDialog">
  <div>
    <app-changepassword (changeStatus)="checkPw($event)"></app-changepassword>
  </div>
</kendo-dialog>
<div id="logout-dialog" *ngIf="openDialog">
  <kendo-dialog [minWidth]="250" [maxWidth]="450">
    <div class="dialog-heading row no-actions">
      <div class="col s12 m2 l2 xl2 color-white background-red icon-col">
        <div>
          <span class="k-icon k-i-warning warningicon"></span>
        </div>
      </div>
      <div class="col s12 m10 l10 xl10 padding-10">
        <div class="align-left">
          {{config.PasswordChangeSuccess}}
          <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>
      </div>
    </div>
  </kendo-dialog>
</div>
